class QueryError extends Error {
	constructor(errorObject) {
		super('GraphQL query failed');
		this.name = 'QueryError';
		this.cause = errorObject;
	}
}

export { QueryError };
